window.addEventListener('load', () => {
  const orderIdWrapper = document.querySelector('.order-id');

  if (orderIdWrapper) {
    const orderId = orderIdWrapper.dataset.id;

    if (sessionStorage) {
      sessionStorage.removeItem('formValues');
    }

    window.location.href = `/profile/orders/${orderId}`;
  }
});
